import React from "react";
import Link from "gatsby-link";
import FullLogoOnWhite from "./full-logo-on-white.svg";
import Fast from "./fast.svg";
import Languages from "./languages.svg";
import StripeCheckout from "react-stripe-checkout";
import { withPrefix } from "gatsby-link";
import Toggle from "react-toggle";
import "./reacttoggle.css";

const STRIPE_PUBLIC_KEY = "pk_test_f1VXBMrmaKoYGGYAtqCHPuga";

const onSelectorChange = () => {
  document.location = "http://graphene-python.org/";
};

class SubscribePage extends React.Component {
  state = {
    annual: false,
    subscribedTo: null
  };
  handleTermChange() {
    this.setState({ annual: !this.state.annual });
  }
  onToken = plan => {
    this.setState({ subscribedTo: plan });
  };

  renderSubscribe(plan) {
    return (
      <StripeCheckout
        ComponentClass="div"
        token={this.onToken.bind(null, plan)}
        name="Quiver Subscription"
        description="Setup the payment details"
        image={withPrefix("/static/logo.png")}
        stripeKey={STRIPE_PUBLIC_KEY}
        allowRememberMe={false}
        panelLabel="Save subscription details"
        billingAddress={true}
      >
        <a
          className="button primary subscribe"
          href={`/signup?trial&plan=${plan}&period=${this.state.annual
            ? "annual"
            : "monthly"}`}
        >
          Start trial
        </a>
      </StripeCheckout>
    );
  }
  render() {
    return (
      <div className="container">
        <header>
          <h1>Quiver Packages</h1>
          <a href={withPrefix("/static/quiver-flyer.pdf")}>See PDF Flyer</a>
        </header>
        <label className="toggle">
          <Toggle
            defaultChecked={this.state.annual}
            icons={false}
            disabled={!!this.state.subscribedTo}
            onChange={this.handleTermChange.bind(this)}
          />{" "}
          <span>Show annual pricing</span>
        </label>
        {this.state.subscribedTo ? (
          <p>
            Payment details for the {this.state.subscribedTo} subscription plan
            saved correctly. We will send you an email with the integration
            instructions soon.
          </p>
        ) : (
          <ol className="packages">
            <li>
              <h2>Cloud</h2>
              <h4 className="plan-price">
                {this.state.annual ? "$2,000/year" : "$200/month"}
              </h4>

              <div>
                The Cloud package is the right fit for small or growing
                companies who are just getting started with GraphQL. It is
                focused primarily on improving the speed of your GraphQL
                queries. The Cloud package includes all of the foundational
                tools you’ll need: quiver package, server plugins, plus world-
                class support to help you make the most of it.
              </div>
              {this.renderSubscribe("basic")}
            </li>
            <li>
              <h2>Enterprise</h2>
              <h4 className="plan-price">
                *<a href="mailto:contact@graphql-quiver.com">contact us</a> for{" "}
                {this.state.annual ? "annual" : "monthly"} pricing
              </h4>
              <div>
                Quiver Enterprise is a step up in functionality from the Cloud
                package. It supports more customized integration and is ideal
                for companies that need to personalize the way the engine works
                to maximize performance on their environment.
              </div>
              {this.renderSubscribe("professional")}
            </li>
          </ol>
        )}
        <style jsx>{`
          /* Rectangle 5: */
          h1 {
            text-align: center;
          }
          .subscribe {
            width: 100%;
            text-align: center;
          }

          .toggle {
            display: block;
            width: 100%;
            text-align: center;
          }
          .button {
            cursor: pointer;
          }
          .plan-price {
            color: #666;
          }
          .packages {
            text-align: center;
          }
          .packages li {
            width: 300px;
            vertical-align: top;
            display: inline-block;
            text-align: center;
            padding: 20px;
            margin: 20px;
            background: #fafafa;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
          }
        `}</style>
      </div>
    );
  }
}

export default SubscribePage;



// WEBPACK FOOTER //
// ./src/pages/pricing.js